import { createFileRoute } from '@tanstack/react-router'
import { Homepage } from 'pages/homepage/Homepage'
import { HomeRedirectContent } from 'pages/redirects/HomeRedirectContent'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const homeDocSearchParamsSchema = z.object({
  docSearch: z.string().optional(),
  docSearchIndex: z.coerce.number().optional(),
  docSearchTab: z.enum(['documents', 'sensors']).optional(),
})

export const Route = createFileRoute('/home/')({
  component: HomeRouteComponent,
  validateSearch: homeDocSearchParamsSchema,
  staticData: {
    title: 'Home',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})

function HomeRouteComponent() {
  const params = Route.useSearch()
  const orgId = params[SEARCH_PARAM_ORG_ID]
  const siteId = params[SEARCH_PARAM_SITE_ID]

  return (
    <HomeRedirectContent orgId={orgId} siteId={siteId}>
      <Homepage orgId={orgId} siteId={siteId} />
    </HomeRedirectContent>
  )
}
